import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M50.9 10c3.2 0 6.3.5 9.4 1.5l53.2 17.9c6.2 2.1 11.6 6.2 15.4 11.7 3.8 5.5 5.9 12.2 5.9 19.1v29.7l16.7-11.2c4-2.7 8.8-3.6 13.4-2.7 4.6 1 8.7 3.8 11.5 7.8l.5.8c1.9 3.1 2.9 6.7 2.9 10.4v82h4.1c1.6 0 3.2.7 4.3 1.9 1.2 1.2 1.8 2.9 1.8 4.6 0 1.7-.6 3.4-1.8 4.6-1.2 1.2-2.7 1.9-4.3 1.9H16.1c-1.6 0-3.2-.7-4.3-1.9-1.2-1.2-1.8-2.9-1.8-4.6 0-1.7.6-3.4 1.8-4.6 1.2-1.2 2.7-1.9 4.3-1.9h4.1V42.3c0-8.4 3.1-16.4 8.6-22.5s13.1-9.5 21-9.8h1.1zm0 12.9c-4.9 0-9.6 2-13 5.7-3.5 3.6-5.4 8.6-5.4 13.7v134.8h90V60.2c0-3.9-1.1-7.8-3.3-11.1-2.1-3.2-5.2-5.7-8.7-7.1l-.8-.3-53.2-17.9c-1.8-.6-3.7-.9-5.6-.9zm115.6 68.7c-.9-1.4-2.3-2.5-3.8-2.8-1.6-.4-3.3-.1-4.6.9l-23.3 15.6v71.8h32.7v-82c0-1-.2-1.9-.6-2.8l-.4-.7zM57 103.8c1.6 0 3.2.7 4.3 1.9 1.2 1.2 1.8 2.9 1.8 4.6v21.5c0 1.7-.6 3.4-1.8 4.6-1.2 1.2-2.7 1.9-4.3 1.9-1.6 0-3.2-.7-4.3-1.9-1.2-1.2-1.8-2.9-1.8-4.6v-21.5c0-1.7.6-3.4 1.8-4.6 1.2-1.2 2.7-1.9 4.3-1.9zm0-51.7c1.6 0 3.2.7 4.3 1.9 1.2 1.2 1.8 2.9 1.8 4.6v21.5c0 1.7-.6 3.4-1.8 4.6-1.2 1.2-2.7 1.9-4.3 1.9-1.6 0-3.2-.7-4.3-1.9-1.2-1.2-1.8-2.9-1.8-4.6V58.6c0-1.7.6-3.4 1.8-4.6 1.2-1.2 2.7-1.9 4.3-1.9z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}